import React from 'react';
import propTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { UiReadOnlyQuill } from 'src/ui/ui-kit/UiReadOnlyQuill';

// Supplemental information is stored HTML (TerraBE task/licenseExpirationTask.py
// writes links such as <a href="/locations/edit/229">View Location Details</a>).
// Those are plain anchors inside the read-only quill body, so following one is a
// full page load carrying no merchant account context — and the merchant pages
// an FI admin is being pointed at are only mounted while that merchant's account
// is selected, so the target route does not exist and the page renders empty.
// Intercept in-app links and switch account context first, the same way drilling
// into a merchant from the Accounts list does.
const isInAppLink = href => /^\/(?!\/)/.test(href || '');

export const SupplementalInformation = ({
  value,
  account,
  user,
  impersonateAccount,
  fetchAccount,
  fetchFormData,
}) => {
  const navigate = useNavigate();

  const handleClick = async event => {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor) {
      return;
    }
    const href = anchor.getAttribute('href');
    if (!isInAppLink(href)) {
      return;
    }
    event.preventDefault();

    if (account && account.id && account.id !== user.accountId) {
      await impersonateAccount({
        accountId: account.id,
        accountName: account.businessName,
      });
      await fetchAccount(account.id);
      if (user.financialInstitutionId) {
        await fetchFormData(user.financialInstitutionId, account.id);
      }
    }

    navigate(href);
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div onClick={handleClick}>
      <UiReadOnlyQuill
        id="supplementalInformation"
        label="Supplemental Information"
        value={value}
      />
    </div>
  );
};

SupplementalInformation.propTypes = {
  value: propTypes.string,
  account: propTypes.object,
  user: propTypes.object.isRequired,
  impersonateAccount: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
  fetchFormData: propTypes.func.isRequired,
};

SupplementalInformation.defaultProps = {
  value: '',
  account: null,
};
